import React, { Component } from "react";
import { Row, Col, Card, Button, Container } from "react-bootstrap";
import BreadcrumbsSection from "../../breadcrumbs/BreadcrumbsSection";
import DataTableWithOutSearch from "../../datatables/DataTableWithOutSearch";
import PackageModal from "./PackageModal";
import PackageModalEdit from "./PackageModalEdit";
import { PageCardShimmer } from "../../preloader/PageCardShimmer";

//import { Data, Columns, defaultSorted } from "./PackageTableData";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from 'moment';
const GET_GLOBALS = gql`
 query($institution_id: Int!) {
          globals(institution_id: $institution_id) {
           exams{
              id
              exam
            }
          }
        }
`;

const GETDATA = gql`
  query($institution_id: Int!) {
    getPackages(institution_id: $institution_id) {
      id
      package_name
      exams_covered
      timestamp
    }
  }
`;

const DELETE_QUERY = gql`
  mutation($id: ID) {
    deletePackage(id: $id)
  }
`;
const FIN = {
  wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
  cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
  iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
  titleText: { display: "flex", flexDirection: "column", textAlign: "left" },
  title: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
  subtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
  countChip: { background: "#f5f3ff", color: "#7c3aed", borderRadius: 20, padding: "4px 12px", fontWeight: 600, fontSize: 12, border: "1px solid #ddd6fe" },
  headerActions: { display: "flex", gap: 10, marginLeft: "auto", alignItems: "center", flexWrap: "wrap" },
  btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
  content: { padding: "20px 24px" },
};

class PackageSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      BreadcrumbData: {
        Title: "Package",
        btnName: "Add Package"
      },
      tableHeaderData: {
        Title: "Package"
      },
      modalShow: false,
      modalShow1: false,
      status: 1,
    };
  }

  getPackages(data) {
    let packages = Array();

    for (let i = 0; i < data.length; i++) {
      packages.push({
        id: data.id,
        package: data.package_name,
        exam: data.exams_covered,
        created: data.timestamp
      });
    }

    return packages;
  }

  actionsFormatter(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" className="text-theme">
          <i className="far fa-edit" />
        </Button>
      </div>
    );
  }

  actionsFormatter2(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" className="text-danger">
          <i className="far fa-trash-alt" />
        </Button>
      </div>
    );
  }

  handleEditFunction = async (e, cell, row, rowIndex, formatExtraData) => {
    console.log("handleedit", row, rowIndex);
    this.setState({
      modalShow1: true,
      editRow: rowIndex
    });
  };
  handleDeleteFunction = async (e, cell, row, rowIndex, formatExtraData) => {
    console.log("Delete Student Parent", rowIndex.id);

    await this.props.deletedata({
      variables: {
        id: parseInt(rowIndex.id)
      },
      update: (store, { data }) => {
        console.log("data", data);
        const data1 = store.readQuery({
          query: GETDATA,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        });

        console.log("rowIndex.id", rowIndex.id);

        data1.getPackages = data1.getPackages.filter(x => x.id != rowIndex.id);

        try {
          store.writeQuery({
            query: GETDATA,
            variables: {
              institution_id: parseInt(Cookies.get("institutionid"))
            },
            data: data1
          });
        } catch (e) {
          console.log("Exception", e);
        }

        const data2 = store.readQuery({
          query: GETDATA,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        });

        console.log("deleted data", data2);
        data1.getPackages = data2;

        //this.props.getPackages = data2.getPackages;

        if (data.deletePackage) {
          this.setState({
            status: 2
          });

          setTimeout(() => {
            this.DeleteSetpageLoad();
          }, 1000);
        }
      }
    });
  };
  DeleteSetpageLoad = () => {
    console.log("setTimeout");
    this.setState({ status: 1 });
  };

  onHide = () => {
    console.log("OnHide", "calling parent");
    this.setState({ modalShow1: false });
  };

  Columns = [
    {
      dataField: "package_name",
      text: "Package Name",
      sort: true
    },
    {
      dataField: "exam_value",
      text: "Exam",
      sort: true,
      headerAlign: "left",
      align: "left"
    },
    {
      dataField: "timestamp",
      text: "Created On",
      sort: true
    },
    {
      dataField: "actions",
      text: "Actions",
      sort: true,
      formatter: this.actionsFormatter,
      headerAttrs: { width: 50 },
      headerAlign: "center",
      align: "center",
      attrs: { width: 50, className: "EditRow" },
      events: {
        onClick: this.handleEditFunction
      }
    },
    {
      dataField: "dactions",
      text: "",
      sort: true,
      formatter: this.actionsFormatter2,
      headerAttrs: { width: 50 },
      headerAlign: "center",
      align: "center",
      attrs: { width: 50, className: "DeleteRow" },
      events: {
        onClick: this.handleDeleteFunction
      }
    }
  ];

  defaultSorted = [
    {
      dataField: "title",
      order: "desc"
    }
  ];

  // handleWindow = e => {
  //   console.log("Window Event", e);

  //   //alert("hello: " + e.type);
  // };

  // componentDidMount() {
  //   console.log("Window Obj", window, this.props);

  //   // if (this.props.history.action === "POP") {
  //   //   console.log("Pressed Back Button.");
  //   // }

  //   //window.addEventListener("click", this.handleWindow);

  //   window.addEventListener("beforeunload", e => {
  //     e.preventDefault();
  //     e.returnValue = "";
  //     console.log("Before unload");
  //     alert("Window closed");
  //   });

  //   const _isMounted = true;
  //   window.onpopstate = e => {
  //     const { hash } = this.props.history.location;

  //     console.log("hash:", hash, e);
  //     if (!window.confirm("Are you sure to Leave this exam?")) {
  //       console.log("Popstate confirm denied");
  //       e.preventDefault();
  //     }
  //   };

  //   window.addEventListener("keydown", this.handleWindow);
  //   window.addEventListener("cancel", this.handleWindow);
  // }

  // componentWillUnmount() {
  //   window.removeEventListener("keydown", this.handleWindow);
  //   window.removeEventListener("cancel", this.handleWindow);
  //   window.removeEventListener("beforeunload", this.handleWindow);
  // }
  tableData(data, globals) {
    console.log("tableData", data);
    let getData = [];
    data.map((mapdata) => {
      let time = moment.unix(mapdata.timestamp).format("YYYY/MM/DD")


      let getexam = globals.exams.find((a) => a.id == mapdata.exams_covered);
      let examval = "";
      if (getexam != undefined) {
        examval = getexam.exam;

      }

      console.log("getexam", globals, getexam, mapdata.exams_covered);
      const newObj = {
        id: mapdata.id,
        package_name: mapdata.package_name,
        exams_covered: mapdata.exams_covered,
        exam_value: examval,
        timestamp: time,
      }
      getData.push(newObj);

    })

    return getData;

  }

  render() {
    console.log("parent packages", this.state);

    const globals = this.props.globals;
    if (this.props.getPackages.loading || globals.loading) return <PageCardShimmer filters={3} />;
    if (globals.error !== undefined) {
      alert("Server Error. " + globals.error.message);
      return null;
    }

    const packages = this.props.getPackages.getPackages;

    return (
      <div style={FIN.wrapper}>
        <Container fluid className="px-0">
          <div style={FIN.card}>
            <div style={FIN.cardHeader}>
              <div style={FIN.iconWrapper}><i className="fal fa-box" /></div>
              <div style={FIN.titleText}>
                <h5 style={FIN.title}>Packages</h5>
                <span style={FIN.subtitle}>Manage exam packages</span>
              </div>
              <div style={FIN.headerActions}>
                <span style={FIN.countChip}>{packages.length} Packages</span>
                <button style={FIN.btnPrimary} onClick={() => this.setState({ modalShow: true })}>
                  <i className="fas fa-plus" /> Add Package
                </button>
              </div>
            </div>
            <div style={FIN.content}>
              {this.state.status == 2 ? <p style={{ color: "#059669", fontWeight: 600 }}>Package deleted successfully</p> : null}
              <DataTableWithOutSearch
                parentData={this.tableData(packages, globals.globals)}
                particlecolumns={this.Columns}
                tableHeading={this.state.tableHeaderData}
                renderAgain={this.state.modalShow1}
              />
            </div>
          </div>
        </Container>
        <PackageModal
          globals={globals.globals}
          show={this.state.modalShow}
          onHide={() => this.setState({ modalShow: false })}
        />
        <PackageModalEdit
          globals={globals.globals}
          show={this.state.modalShow1}
          packages={packages}
          editRow={this.state.editRow}
          onHide={this.onHide}
        />
      </div>
    );
  }
}

export default withRouter(
  compose(
    graphql(GETDATA, {
      options: props => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid"))
        }
        ,
        fetchPolicy: 'network-only'
      }),
      name: "getPackages"
    }),
    graphql(
      GET_GLOBALS,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          },
          fetchPolicy: 'network-only'
        }),
        name: "globals"
      }
    ),

    graphql(DELETE_QUERY, {
      name: "deletedata"
    })
  )(PackageSection)
);
